import React from 'react';
import {withStyles} from "@material-ui/core/styles";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton} from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import SurveySelectMenu from "./SurveySelectMenu";

const styles = {
  content:{
    padding: "0",
    borderTop: "1px solid #ddd",
  },
  label:{
    fontSize: "0.85rem",
    fontWeight: "500",
    opacity: "0.87",
    textAlign: "center",
    width: "fit-content",
  },
  container:{
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
};


function SurveySelectDialog(props) {
  const {
    isOpen, closeDialog, filterName, itemChangeCallback, openDataView, className,
    folderList, addFolder,
    id="surveySelectDialog", classes, ...dialogProps } = props;

  return (
    <Dialog {...dialogProps} PaperProps={{id:id}} className={className} open={isOpen} onClose={closeDialog} fullWidth maxWidth="md">
      <DialogTitle>
        <div style={{display:'flex', flexWrap:'wrap-reverse', justifyContent:'space-between'}}>
         Select an assessment to begin.
          <IconButton onClick={closeDialog} style={{width:'2rem', height:'2rem', margin:'-0.5rem 0 0 auto'}}>
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <SurveySelectMenu
          itemChangeCallback={() => {
            itemChangeCallback();
          }}
          openDataView={id => {
            closeDialog();
            openDataView(id);
          }}
          filterName={val => {
            closeDialog();
            filterName(val);
          }}
          folderList={folderList}
          addFolder={addFolder}
        />
      </DialogContent>
      <DialogActions>
        <Button id="selectSurveyCancel" onClick={closeDialog} variant="contained" color="secondary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default withStyles(styles)(SurveySelectDialog);
